// Autogenerated by `pnpm version-file`. DO NOT EDIT
export var VERSION = '1.51.6';
//# sourceMappingURL=version.js.map